const sameIncidents = (previous = [], next = []) => {
  if (!Array.isArray(previous) || !Array.isArray(next)) return false
  if (previous.length !== next.length) return false

  for (let i = 0; i < previous.length; i += 1) {
    const a = previous[i]
    const b = next[i]
    if (
      a?.id !== b?.id ||
      a?.incident_date !== b?.incident_date ||
      a?.status !== b?.status ||
      a?.updatedAt !== b?.updatedAt
    ) {
      return false
    }
  }

  return true
}

const incidents = (incidents = [], action) => {
  switch (action.type) {
    case 'FETCH_INCIDENTS':
      return sameIncidents(incidents, action.payload) ? incidents : action.payload
    default:
      return incidents
  }
}
export default incidents
